import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import auth from './modules/auth';
import profile from './modules/profile-module';
import roles from './modules/roles-module';
import teams from './modules/teams-module';
import economicModel from './modules/economicModel-module';
import cos from './modules/cos-module';
import observed from './modules/observed-module';
import notifications from './modules/notifications-module';
import communities from './modules/communities-module';
import integrations from './modules/integrations-module';
import demo from './modules/demo-module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    profile,
    roles,
    teams,
    economicModel,
    cos,
    observed,
    notifications,
    communities,
    integrations,
    demo
  },
  plugins: [createPersistedState()]
});
